module.exports = "/assets/a63c1cb766392775287033cbf13cc835.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RV.png
// module id = 2922
// module chunks = 0